<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  @import "../common/style/variables";

  .navbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #fff;
    z-index: 1000;
    padding-left: calc(100vw - 100%);
    box-shadow: 0 2px 4px 0 #DDDDDD;
    .container {
      position: relative;
      width: 1200px;
      min-width: 1200px;
      height: 100px * @scaleRate;
      &.minScreen {
        width: 1000px;
        min-width: 1000px;
      }
      &-header {
        min-width: 900px;
      }
      .logo {
        cursor: pointer;
        position: absolute;
        bottom: 4.25px;
        margin-left: -134px * @scaleRate;
        img {
          width: 100px * @scaleRate;
          height: 44px * @scaleRate;
        }
      }
      .router-list {
        position: absolute;
        bottom: 0;
        .router-item {
          display: inline-block;
          font-size: 24px * @scaleRate;
          line-height: 33px * @scaleRate;
          margin-right: 2.15384rem * @scaleRate;
          position: relative;
          padding-bottom: 7px * @scaleRate;
          cursor: pointer;
          color: #111;

          &:hover {
            color: #4b89f3;
          }
          &:last-child {
            margin-right: 0;
          }
          &.active {
            color: #4b89f3;
            &::after {
              content: '';
              position: absolute;
              display: block;
              background: #4b89f3;
              bottom: 0;
              height: 3px;
              width: 100%;
              border-radius: 100px;
            }
          }
          span{
            height: 25px;
            width: 22px;
            color: #F44A38;
            padding-bottom: 300px;
            margin-bottom: 600px;
            margin-left: -5px;
            font-family: PingFangSC-Regular;
            font-size: 18px * @scaleRate;
            position: absolute;
            right: -17px;
            top: -12px;
          }
        }
      }
      .user {
        position: absolute;
        bottom: 0;
        right: 0;
        padding-bottom: 5px;
        .user-draft, .user-name {
          font-size: 20px * @scaleRate;
          color: #4c4c4c;
          display: inline-block;
          img {
            vertical-align: -3px * @scaleRate;
          }
        }
        .user-draft {
          margin-right: 30px * @scaleRate;
          cursor: pointer;
          img {
            width: 20px * @scaleRate + 4px;
            height: 20px * @scaleRate;
          }
        }
        .user-name {
          img {
            width: 50px * @scaleRate;
            height: 50px * @scaleRate;
            border-radius: 50%;
            box-sizing: border-box;
            border: 1px solid #8f8f8f;
            box-shadow: 0 0 6px 0 #8f8f8f;
            overflow: hidden;
          }
        }
      }
      .quit {
        position: absolute;
        padding-bottom: 5px;
        bottom: 0;
        right: -135px * @scaleRate;
        font-size: 20px * @scaleRate;
        color: #4c4c4c;
        cursor: pointer;
        img {
          width: 17px;
          height: 17px;
          vertical-align: -2.5px;
        }
      }

    }
  }


</style>

<template>
  <nav class="navbar">
    <div class="container container-header" :class="clientWidth <= 1440 ? 'minScreen' : ''">
      <div class="logo">
        <img @click="handleLogoClick" src="../common/image/logo.png" alt="logo">
      </div>
      <div class="router-list">
        <div class="router-item"
             :class="{active: router.name === routerName, awaitReason: router.title === '待回答'}"
             v-for="router in routerList"
             @click="switchPage(router)">
          {{router.title}}
          <p style="display:inline;" v-if="router.title==='待回答' && unReadNum">（{{unReadNum}}）</p>
          <span v-if="router.title==='我的粉丝' && userInfo.newFansNum " class="new-fans">+{{userInfo.newFansNum}}</span>
          <span v-if="router.title==='通知' && messageNoReadCount" class="new-fans">+{{messageNoReadCount}}</span>
        </div>
      </div>
      <div class="user">
        <!--<div @click="switchPage({path:'/draft'})" class="user-draft">
          <img id="icon-draft" src="../common/image/caogaoxiang.png" alt="草稿箱">
          <span>草稿箱</span>
        </div>-->
        <div class="user-name">
          <img :src="userInfo.photo ? userInfo.photo : require('../common/image/caogaoxiang.png')" alt="头像">
          <span>{{userInfo.nickName || '昵称'}}</span>
        </div>
      </div>
      <div @click="quitAcount" class="quit">
        <img src="../common/image/tuichu.png" alt="退出登录">
        退出登录
      </div>
    </div>
  </nav>
</template>

<script>
  import {appRouter} from '../router/routes'
  import {mapState} from 'vuex'
  import {getWindowWidth} from '../common/util/dom'

  export default {
    data () {
      return {
        routerList: appRouter.children.slice(0, 6),
        clientWidth: getWindowWidth(),
        Fans:true,
        messageNoReadCount:0
      }
    },
    computed: {
      routerName () {
        return this.$route.name
      },
      ...mapState({
        userInfo: state => state.app.userInfo,
        unReadNum: state => state.app.unReadNum
      })
    },
    methods: {
      switchPage (item) {
        console.log(item)
        this.$router.push(item.path)
        if(item.path=='/fans'){
            this.$store.commit('removeFans')
        }
      },
      quitAcount () {
        window.localStorage['token'] = ''
        this.$store.commit('logoutAcount')
        this.$router.push('login')
      },
      handleLogoClick (evt) {
        this.$eventHub.$emit('logoClick', evt)
      },
      loadExpertMessageNoReadNum () {
          this.$ajax.getExpertMessageNoReadNum({}).then((res) => {
              console.log(res)
              if(res.code=='0'){
                  this.messageNoReadCount= res.data.expertCommentRepliedMessageNoReadNum+res.data.expertReasonLikedMessageNoReadNum+res.data.expertReasonRepliedMessageNoReadNum
                  this.$store.commit('setNotice',this)
              }
          })
      },
      // 获取待回答数量
      loadUnReadNum () {
        this.$ajax.loadUnReadNum({}).then((res) => {
          console.log(res)
          if(res.code=='0'){
            // this.unReadNum= res.data
            this.$store.commit('setUnReadNum',res.data)
          }
        })
      }
    },
    mounted () {
       this.loadExpertMessageNoReadNum()
       this.loadUnReadNum()
       window.addEventListener('resize', () => {
        this.clientWidth = getWindowWidth()
       })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/wt-header.vue